import React from 'react';

const ScriptManager: React.FC = () => {
  // Simple placeholder - not rendered by default
  return null;
};

export default ScriptManager;
